"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolPencilLineIcon32Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ToolPencilLineIcon32Regular = forwardRef_1.forwardRef('ToolPencilLineIcon32Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 32 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.388 4.885a3 3 0 0 1 4.243 0l1.485 1.485a3 3 0 0 1 0 4.242l-16.51 16.51a3 3 0 0 1-2.12.878H4.5A1.5 1.5 0 0 1 3 26.5v-2.985a3 3 0 0 1 .879-2.121l16.51-16.51Zm2.829 1.414a1 1 0 0 0-1.415 0l-2.395 2.396 2.899 2.9 2.396-2.397a1 1 0 0 0 0-1.414l-1.485-1.485ZM5.293 22.809l12.7-12.7 2.899 2.9-12.7 12.699a1 1 0 0 1-.707.293H5v-2.486a1 1 0 0 1 .293-.707Z" }),
        react_1.default.createElement("path", { d: "M15 26a1 1 0 1 0 0 2h13a1 1 0 0 0 0-2H15Z" })));
});
